import type { ReactNode } from 'react';
import { Button, Dialog, useToast } from '@/components/ui';
import { isApiError } from '@/lib/api';
import styles from '@/pages/ops/parity.module.css';

/** Drawer with Cancel/Save that toasts the API result and closes on success. */
export function FormDialog({
  title,
  onClose,
  onSubmit,
  pending,
  disabled,
  submitLabel = 'Save',
  children,
}: {
  title: string;
  onClose: () => void;
  onSubmit: () => Promise<unknown>;
  pending: boolean;
  disabled?: boolean;
  submitLabel?: string;
  children: ReactNode;
}) {
  const toast = useToast();
  return (
    <Dialog
      open
      title={title}
      onClose={onClose}
      dismissible={!pending}
      footer={
        <>
          <Button onClick={onClose}>Cancel</Button>
          <Button
            variant="primary"
            loading={pending}
            disabled={disabled}
            onClick={() =>
              void onSubmit()
                .then(() => {
                  toast.show({ tone: 'success', title: 'Saved' });
                  onClose();
                })
                .catch((err: unknown) =>
                  toast.show({
                    tone: 'error',
                    title: 'Not saved',
                    body: isApiError(err) ? err.message : undefined,
                    error: err,
                  }),
                )
            }
          >
            {submitLabel}
          </Button>
        </>
      }
    >
      <div className={styles.form}>{children}</div>
    </Dialog>
  );
}
